import { stat } from "fs";

const logSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_LOGSEARCH: (state, logSearch) => {
      state.data = logSearch
    }
  }
}

export default logSearch



// WEBPACK FOOTER //
// ./src/store/modules/logSearch.js